export default `uniform vec4 u_chunk_rect;

varying vec4 v_component_coords;

void main() {
    
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec3 modelNormal = normalize(normalMatrix * normal);

    gl_Position = projectionMatrix * viewMatrix * modelPosition;

    v_component_coords = vec4(
    mix(u_chunk_rect.xy, u_chunk_rect.zw, uv),
    mix(u_chunk_rect.zw, u_chunk_rect.xy, uv));
}`